module.exports = __webpack_public_path__ + "static/img/2345acceleration.ba467570.png";